import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import miciCasesService from '../../../services/miciCasesService';
import { NumberRoute } from '../../../types';
import Context from './MiciCaseContext';
import MainContext from '../../App/MainProvider/context';
import { MiciCaseContext } from '../../../services/types/MiciCases';

const MiciCaseProvider: React.FC<NumberRoute> = ({ number, children }) => {
  const { service, notify } = useContext(MainContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<MiciCaseContext | null>(null);

  const loadData = useCallback(
    () =>
      service(() => miciCasesService.getMiciCaseContext(number), {
        loader: setLoading,
        callback: (mici) => {
          if (mici) {
            setData(mici);
          } else {
            notify(t('error'), t('miciCaseNotFound'), 'danger');
            setTimeout(() => {
              navigate('/');
            }, 200);
          }
        },
      }),
    [number, service]
  );

  const reload = useCallback(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (number) {
      loadData();
    }
  }, [number]);

  const value = useMemo(() => data && { data, reload, loading }, [data, reload, loading]);

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default MiciCaseProvider;
